import React, { lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { config } from './components/pages/config'
import index from './components/pages/Home'
import NotFound from './components/common/NotFound'

// Pages other than Home load on demand, so the first visit downloads less JavaScript.
const InstructorIndex = lazy(() => import('./components/pages/Instructors'))
const CoursesIndex = lazy(() => import('./components/pages/Courses'))
const ContactIndex = lazy(() => import('./components/pages/Contact'))
const CourseDetails = lazy(() => import('./components/pages/Courses/CourseDetails'))
const FaqIndex = lazy(() => import('./components/pages/Faqs'))
const InstructorDetails = lazy(() => import('./components/pages/Instructors/InstructorDetails'))
const BookingIndex = lazy(() => import('./components/pages/Booking'))
const BookingDetails = lazy(() => import('./components/pages/Booking/BookingDetails'))
const AboutTheoryCourse = lazy(() => import('./components/pages/About Courses/AboutTheoryCourse'))
const AboutPracticalCourse = lazy(() => import('./components/pages/About Courses/AboutPracticalCourse'))
const BecomeInstructor = lazy(() => import('./components/pages/Instructors/BecomeInstructor'))
const BlogIndex = lazy(() => import('./components/pages/Blogs'))
const BlogDetails = lazy(() => import('./components/pages/Blogs/BlogDetails'))
const LocationsIndex = lazy(() => import('./components/pages/Locations'))
const TermsConditions = lazy(() => import('./components/pages/Company Details/TermsConditions'))
const PrivacyPolicy = lazy(() => import('./components/pages/Company Details/PrivacyPolicy'))
const RefundDelivery = lazy(() => import('./components/pages/Company Details/RefundDelivery'))
const CookiePolicy = lazy(() => import('./components/pages/Company Details/CookiePolicy'))
const GetStarted = lazy(() => import('./components/pages/Get Started'))
const RefresherPage = lazy(() => import('./components/pages/Refresher driver'))
const Gallery = lazy(() => import('./components/pages/Gallery/Gallery'))
const PaymentSuccess = lazy(() => import('./components/common/PaymentSuccess'))

const AllRoutes = () => {

    const location = useLocation()

    useEffect(() => {
        // move to top when page change
        window.scrollTo({ top: 0, behavior: 'instant' })
    }, [location.pathname])

    return (
        <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
        <Routes>
            <Route path="*" Component={NotFound} />
            <Route path={`${config.appUrl}`} Component={index} />
            <Route path={`${config.appUrl}get-started`} Component={GetStarted} />
            <Route path={`${config.appUrl}instructors`} Component={InstructorIndex} />
            <Route path={`${config.appUrl}instructor`} Component={InstructorDetails} />
            <Route path={`${config.appUrl}courses`} Component={CoursesIndex} />
            <Route path={`${config.appUrl}courses/:course_slug`} Component={CourseDetails} />
            <Route path={`${config.appUrl}course/:course_slug`} Component={CourseDetails} />
            <Route path={`${config.appUrl}contact-us`} Component={ContactIndex} />
            <Route path={`${config.appUrl}faqs`} Component={FaqIndex} />
            <Route path={`${config.appUrl}refresher-driver-lessons`} Component={RefresherPage} />
            <Route path={`${config.appUrl}blogs`} Component={BlogIndex} />
            <Route path={`${config.appUrl}blog/:post_slug`} Component={BlogDetails} />
            <Route path={`${config.appUrl}gallery`} Component={Gallery}/>

            {/* Booking Process Routes */}
            <Route path={`${config.appUrl}book-a-lesson`} Component={BookingIndex} />
            <Route path={`${config.appUrl}booking-details`} Component={BookingDetails} />
            <Route path={`${config.appUrl}reschedule`} Component={BookingIndex} />
            <Route path={`${config.appUrl}our-locations`} Component={LocationsIndex} />

            <Route path={`${config.appUrl}about-theory-test`} Component={AboutTheoryCourse} />
            <Route path={`${config.appUrl}about-practical-test`} Component={AboutPracticalCourse} />

            <Route path={`${config.appUrl}how-to-become-instructor`} Component={BecomeInstructor} />
            <Route path={`${config.appUrl}terms-and-conditions`} Component={TermsConditions} />
            <Route path={`${config.appUrl}privacy-policy`} Component={PrivacyPolicy} />
            <Route path={`${config.appUrl}refund-and-Delivery`} Component={RefundDelivery} />
            <Route path={`${config.appUrl}cookie-policy`} Component={CookiePolicy} />

            <Route path={`${config.appUrl}payment/:pay_status`} Component={PaymentSuccess} />

        </Routes>
        </Suspense>
    )
}

export default AllRoutes